import { z } from "zod";
/** Environment of an attributed resource. */
export const ENVIRONMENTS = ["DEVELOPMENT", "TESTING", "PRODUCTION"];
export const environmentSchema = z.enum(ENVIRONMENTS);
/** Where an attributed dimension value came from, in order of precedence. */
export const ATTRIBUTION_SOURCES = ["LABEL", "INVENTORY_LABEL", "INHERITED", "KUBERNETES", "UNASSIGNED"];
export const attributionSourceSchema = z.enum(ATTRIBUTION_SOURCES);
/** Kind of a tenant, derived from its code. */
export const TENANT_KINDS = ["CUSTOMER", "INTERNAL", "SHARED"];
export const tenantKindSchema = z.enum(TENANT_KINDS);
/** Level order of the cost tree. */
export const HIERARCHIES = ["SERVICE_TENANT", "TENANT_SERVICE"];
export const hierarchySchema = z.enum(HIERARCHIES);
/** Kind of a collector run. */
export const COLLECTOR_RUN_KINDS = ["BILLING", "INVENTORY"];
export const collectorRunKindSchema = z.enum(COLLECTOR_RUN_KINDS);
/** State of a collector run. */
export const COLLECTOR_RUN_STATUSES = ["RUNNING", "SUCCEEDED", "FAILED"];
export const collectorRunStatusSchema = z.enum(COLLECTOR_RUN_STATUSES);
/** User roles granted by the identity provider. */
export const ROLES = ["cost-viewer"];
export const roleSchema = z.enum(ROLES);
/** Enumerated API error codes; the frontend translates them as `error.<CODE>`. */
export const ERROR_CODES = [
    "INTERNAL_ERROR",
    "VALIDATION_FAILED",
    "UNAUTHENTICATED",
    "FORBIDDEN",
    "NOT_FOUND",
    "RATE_LIMITED",
    "PAYLOAD_TOO_LARGE",
    "OPERATION_IN_PROGRESS",
];
export const errorCodeSchema = z.enum(ERROR_CODES);
//# sourceMappingURL=codes.js.map